export default "__VITE_ASSET__D$qQEBrW__"